import { Waves, Trees, Home as HouseIcon, BedDouble, Utensils, Flame, Wifi, Car, Sparkles } from "lucide-react";
import { FadeUp, SectionHeader } from "./Reveal.jsx";
import { useSiteContent } from "@/content/ContentContext.jsx";

const ICONS = [Waves, Trees, HouseIcon, BedDouble, Utensils, Flame, Wifi, Car];

const Facilities = () => {
  const { content } = useSiteContent();
  const c = content.facilities;

  return (
    <section id="facilities" className="relative py-20 sm:py-28 lg:py-36" data-testid="facilities-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-10">
        <SectionHeader eyebrow={c.eyebrow} title={c.title} lead={c.lead} testid="facilities-eyebrow" />

        <div className="mt-14 grid grid-cols-1 gap-x-16 lg:grid-cols-2">
          {c.items.map((f, i) => {
            const Icon = ICONS[i % ICONS.length] || Sparkles;
            return (
              <FadeUp key={f.name + i} delay={0.04 * (i % 4)}>
                <article
                  className="group flex items-start gap-5 border-t hairline py-8 transition-colors duration-300 hover:bg-brand-tint/70 sm:px-4"
                  data-testid={`facility-item-${i + 1}`}
                >
                  <span className="mt-1 font-display text-sm italic text-brand-light/80">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-tint2 text-brand transition-all duration-300 group-hover:bg-brand group-hover:text-white">
                    <Icon size={22} />
                  </span>
                  <div>
                    <h3 className="font-display text-xl text-brand">{f.name}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-zinc-600">{f.desc}</p>
                  </div>
                </article>
              </FadeUp>
            );
          })}
          <div className="hidden border-t hairline lg:block" />
        </div>
      </div>
    </section>
  );
};

export default Facilities;
